export default function(prefix, length) {
  prefix = prefix || "";
  length = length || 10;

  var text = "";
  var possible =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

  for (var i = 0; i < length; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return prefix + "_" + text;
}



// WEBPACK FOOTER //
// ./src/helpers/make-id.js